import { render, staticRenderFns } from "./Associazioni.vue?vue&type=template&id=47eed282&scoped=true&"
import script from "./Associazioni.vue?vue&type=script&lang=js&"
export * from "./Associazioni.vue?vue&type=script&lang=js&"
import style0 from "./Associazioni.vue?vue&type=style&index=0&id=47eed282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eed282",
  null
  
)

export default component.exports